// extracted by mini-css-extract-plugin
export default {"root":"AdmarktRegistrationStepLinkAccount-root","infoList":"AdmarktRegistrationStepLinkAccount-infoList"};